module.exports = __webpack_public_path__ + "img/icon_zj_bgs.837da67f.png";